import React from "react";
import { VehicleProvider } from "../lib/vehicleContext";
import { Header } from "../sections/Header";
import { Hero } from "../sections/Hero";
import { About } from "../sections/About";
import { VeteranInitiative } from "../sections/VeteranInitiative";
import { Features } from "../sections/Features";
import { FourPillars } from "../sections/FourPillars";
import { HowItWorks } from "../sections/HowItWorks";
import { DemoDashboard } from "../sections/DemoDashboard";
import { Pricing } from "../sections/Pricing";
import { FAQ } from "../sections/FAQ";
import { FinalCTA } from "../sections/FinalCTA";
import { ShareCommunity } from "../sections/ShareCommunity";
import { TrustScoreExplainer } from "../sections/TrustScoreExplainer";
import { ReviewStrip } from "../sections/ReviewStrip";
import { BlogTeaser } from "../sections/BlogTeaser";
import { Footer } from "../sections/Footer";
import { StickyTryFreePill } from "../components/StickyTryFreePill";
import { VoteNudge } from "../components/VoteNudge";
import { StripeSuccessAutoActivate } from "../components/StripeSuccessAutoActivate";
import Seo from "../components/Seo";

export default function Landing({
  seoTitle = "EVIQ — Tesla battery health, warranty, and Digital Battery Passport",
  seoDescription = "Independent battery intelligence for Tesla, Ford & Volvo/Polestar EV owners. Track SoH, forecast degradation, protect your warranty, and generate a cryptographically-signed Battery Passport that boosts resale value.",
  canonical = "https://eviq.pro/",
  scrollTo,
}) {
  React.useEffect(() => {
    if (!scrollTo) return undefined;
    const t = setTimeout(() => {
      document.getElementById(scrollTo)?.scrollIntoView({ behavior: "smooth" });
    }, 400);
    return () => clearTimeout(t);
  }, [scrollTo]);

  return (
    <VehicleProvider>
      <Seo title={seoTitle} description={seoDescription} canonical={canonical} />
      <div className="min-h-screen bg-black text-white" data-testid="landing-page">
        <a href="#main-content" className="skip-to-content" data-testid="skip-to-content">
          Skip to main content
        </a>
        <Header />
        <main id="main-content" tabIndex="-1">
          <Hero />
          <About />
          <VeteranInitiative />
          <Features />
          <FourPillars />
          <TrustScoreExplainer />
          <HowItWorks />
          <DemoDashboard />
          <ReviewStrip />
          <Pricing />
          <FAQ />
          <BlogTeaser />
          <ShareCommunity />
          <FinalCTA />
        </main>
        <Footer />
        <StickyTryFreePill />
        <VoteNudge />
        <StripeSuccessAutoActivate />
      </div>
    </VehicleProvider>
  );
}
